class KombinDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('[data-kd-overlay]');
    this.closeBtn = this.querySelector('[data-kd-close]');
    this.addAllBtn = this.querySelector('[data-kd-add-all]');
    this.body = this.querySelector('[data-kd-body]');
  }

  connectedCallback() {
    this.overlay?.addEventListener('click', () => this.close());
    this.closeBtn?.addEventListener('click', () => this.close());
    this.addAllBtn?.addEventListener('click', () => this.addAll());

    this.querySelectorAll('[data-kd-add-single]').forEach(btn => {
      btn.addEventListener('click', (e) => this.addSingle(e));
    });
  }

  open() {
    this.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.removeAttribute('open');
    document.body.style.overflow = '';
  }

  async addSingle(e) {
    const btn = e.currentTarget;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('loading');
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('Add failed');

      btn.querySelector('.button__text').textContent = btn.dataset.addedText || 'Eklendi ✓';
      setTimeout(() => {
        btn.querySelector('.button__text').textContent = btn.dataset.addText || 'Sepete Ekle';
        btn.disabled = false;
      }, 1500);

      this.refreshCart();
    } catch (err) {
      btn.disabled = false;
    } finally {
      btn.classList.remove('loading');
    }
  }

  async addAll() {
    const btn = this.addAllBtn;
    if (!btn) return;

    const items = [];
    this.querySelectorAll('[data-kd-add-single]').forEach(el => {
      const vid = el.dataset.variantId;
      if (vid && !el.disabled) items.push({ id: parseInt(vid), quantity: 1 });
    });

    if (!items.length) return;

    btn.classList.add('loading');
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('Add all failed');

      window.location.href = '/cart';
    } catch (err) {
      btn.disabled = false;
    } finally {
      btn.classList.remove('loading');
    }
  }

  refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(el => {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('.cart-count-bubble').forEach(el => {
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(() => {});
  }
}

customElements.define('kombin-drawer', KombinDrawer);

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-kd-open]');
  if (!trigger) return;
  e.preventDefault();
  const drawerId = trigger.dataset.kdOpen;
  const drawer = document.getElementById(drawerId);
  if (drawer) drawer.open();
});

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-kd-add-single]');
  if (!btn || btn.closest('kombin-drawer')) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  e.preventDefault();
  e.stopPropagation();

  btn.classList.add('loading');
  btn.disabled = true;

  const cartDrawer = document.querySelector('cart-drawer');
  const body = {
    items: [{ id: parseInt(variantId), quantity: 1 }],
    sections: 'cart-drawer,cart-icon-bubble',
    sections_url: window.location.pathname
  };

  const baseUrl = window.routes?.cart_add_url || (window.Shopify?.routes?.root || '/') + 'cart/add';
  const cartAddUrl = baseUrl.endsWith('.js') ? baseUrl : baseUrl + '.js';
  fetch(cartAddUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
    .then(r => { if (!r.ok) throw new Error(); return r.json(); })
    .then((response) => {
      const textEl = btn.querySelector('.button__text');
      if (textEl) {
        textEl.textContent = btn.dataset.addedText || 'Eklendi ✓';
        setTimeout(() => {
          textEl.textContent = btn.dataset.addText || 'Sepete Ekle';
          btn.disabled = false;
        }, 1500);
      }
      if (cartDrawer && response.sections) {
        try {
          const parsedState = {
            id: response.items?.[0]?.variant_id || variantId,
            sections: response.sections
          };
          cartDrawer.setActiveElement(btn);
          cartDrawer.renderContents(parsedState);
        } catch (err) {
          cartDrawer.open();
          const cartJsUrl = (window.Shopify?.routes?.root || '/') + 'cart.js';
          fetch(cartJsUrl).then(r => r.json()).then(cart => {
            document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(el => { el.textContent = cart.item_count; });
            document.querySelectorAll('.cart-count-bubble').forEach(el => { el.style.display = cart.item_count > 0 ? '' : 'none'; });
          });
        }
      } else if (cartDrawer) {
        const cartJsUrl = (window.Shopify?.routes?.root || '/') + 'cart.js';
        fetch(cartJsUrl)
          .then(r => r.json())
          .then(cart => {
            document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(el => { el.textContent = cart.item_count; });
            document.querySelectorAll('.cart-count-bubble').forEach(el => { el.style.display = cart.item_count > 0 ? '' : 'none'; });
          });
        cartDrawer.open();
      } else {
        const cartJsUrl = (window.Shopify?.routes?.root || '/') + 'cart.js';
        fetch(cartJsUrl)
          .then(r => r.json())
          .then(cart => {
            document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(el => { el.textContent = cart.item_count; });
            document.querySelectorAll('.cart-count-bubble').forEach(el => { el.style.display = cart.item_count > 0 ? '' : 'none'; });
          });
      }
    })
    .catch(() => { btn.disabled = false; })
    .finally(() => { btn.classList.remove('loading'); });
});
